import { useQuery } from '@tanstack/react-query';
import { generalSearchRequest } from 'src/requests/search';
import { QueryKey, queryRetry } from 'src/utils/react-query';
import { SortByEnum } from './shared/types';

export function useGeneralSearchQuery(searchTerm: string, sortBy: SortByEnum) {
  const { data, isFetching, isLoading, refetch } = useQuery(
    [QueryKey.SEARCH, sortBy, searchTerm],
    () => generalSearchRequest(searchTerm, sortBy),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: queryRetry,
      enabled: !!searchTerm,
    },
  );

  return {
    data,
    isLoading,
    isFetching,
    refetch,
  };
}
